module.exports = __webpack_public_path__ + "img/information.d4a084a3.svg";